
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from "react";
import useTranslation from "next-translate/useTranslation";
import Trans from "next-translate/Trans";

import { Head } from "@/components/Head";
import { useTheme } from "@/hooks/useTheme";
import { Converter } from "@/containers/Converter";

import { MagicianSection } from "@/sections/MagicianSection";
import { TrustedBySection } from "@/sections/TrustedBySection";
import { SelectFormatSection } from "@/sections/SelectFormatSection";
import { ApiTeaserSection } from "@/sections/ApiTeaserSection";
import { CTASection } from "@/sections/CTASection";
import { ConversionSection } from "@/sections/ConversionSection";
import { ShareDesignSection } from "@/sections/ShareDesignSection";
import { CustomersLogosSection } from "@/sections/CustomersLogosSection";
import { PricingSection } from "@/sections/PricingSection";
import { useFeatureFlags } from "@/hooks/useFeatureFlags";

const PdfToXd = () => {
  const { t } = useTranslation();
  const { colors } = useTheme();
  const { isFeatureEnabled } = useFeatureFlags();

  return (
    <>
      <Head
        pageNamespace="page/PDFToXD"
        ogImage="/images/pdf2xd-og-image.jpg"
      />

      <MagicianSection
        title={t("page/PDFToXD:title")}
        subtitle={t("page/PDFToXD:subtitle")}
        magicianLogoFile="pdf"
        cta={{
          title: t("section/magicians:seeHowItWorks"),
          scrollToId: "ApiTeaserSection",
        }}
      >
        <Converter disabled={!isFeatureEnabled("DISPLAY_PDF_CONVERTERS")} />
      </MagicianSection>

      <TrustedBySection />

      <ApiTeaserSection
        title={
          ((
            <Trans
              i18nKey="page/PDFToXD:section/apiTeaser.title"
              components={[<span style={{ color: colors.ORANGE }} key={0} />]}
            />
          ) as unknown) as string
        }
        image={{
          src: "/images/pdf-to-xd-example.png",
          alt: "PDF to Adobe XD converter example",
        }}
        backgroundColor={colors.LIGHT_GRAY1}
        cta={{
          title: t("common:actions.doNow", { do: t("common:actions.convert") }),
        }}
        elements={t("page/PDFToXD:section/apiTeaser.apiTeaserElements", null, {
          returnObjects: true,
        })}
      />

      <ShareDesignSection
        id="ShareDesignSection"
        title={
          ((
            <Trans
              i18nKey="page/PDFToXD:section/shareDesign.title"
              components={[<span key="0" style={{ color: colors.ORANGE }} />]}
            />
          ) as unknown) as string
        }
        image={{
          src: "/images/import-pdf-into-xd.jpg",
          alt: t("page/PDFToXD:section/shareDesign.imageAlt"),
        }}
        backgroundColor={colors.LIGHT_GRAY1}
        cta={{
          title: t("page/PDFToXD:section/shareDesign.ctaButton"),
        }}
        elements={[
          {
            id: "ELEMENT#1",
            iconType: "SPREAD-ICON",
            title: t(
              "page/PDFToXD:section/shareDesign.elements.pathElementsTitle",
            ),
            text: t(
              "page/PDFToXD:section/shareDesign.elements.pathElementsText",
            ),
          },
          {
            id: "ELEMENT#2",
            iconType: "FOLDER-SIMPLE-ICON",
            title: t(
              "page/PDFToXD:section/shareDesign.elements.folderStructureTitle",
            ),
            text: t(
              "page/PDFToXD:section/shareDesign.elements.folderStructureText",
            ),
          },
          {
            id: "ELEMENT#3",
            iconType: "CHECK-GREEN-ICON",
            title: t(
              "page/PDFToXD:section/shareDesign.elements.imageSupportTitle",
            ),
            text: t(
              "page/PDFToXD:section/shareDesign.elements.imageSupportText",
            ),
          },
        ]}
      />

      <PricingSection />

      <ConversionSection
        title={t("section/conversion:title")}
        iconBadges={[
          {
            iconType: "SHEETS",
            text: t("section/conversion:badges.supportsAll"),
          },
          {
            iconType: "TV",
            text: t("section/conversion:badges.accuracy"),
          },
        ]}
        elements={{
          from: {
            iconType: "PDF",
            image: "/images/pdf-example.png",
            title: "PDF Demo Preview",
          },
          to: {
            iconType: "ADOBEXD",
            image: "/images/xd-preview.jpg",
            title: "Adobe XD PDF Import Demo Preview",
          },
        }}
      />

      <CustomersLogosSection />
      <SelectFormatSection title={t("section/selectFormat:title")} />

      <CTASection
        title={t("section/cta:titles.figmaToPsdPage")}
        href="#upload"
      />
    </>
  );
};

// Temporal workaround for https://github.com/vercel/next.js/discussions/18396
 async function _getStaticProps() {
  return {
    props: {},
  };
}

export default PdfToXd;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/converter/pdf-to-xd',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  